/**
 * src/web/components/pdf-preview-page.jsx
 * PDFファイル表示用コンポーネント
 */

import React from 'react'
import ReactDOM from 'react-dom'
import { translate } from 'react-i18next'
import RightSidePage from './right-side-page.jsx'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import FontIcon from 'react-toolbox/lib/font_icon'
import pdfPreviewTheme from './themes/pdf-preview.css'
import Tooltip from 'react-toolbox/lib/tooltip'
import { Document, Page, setOptions } from 'react-pdf';
import i18next from '../../i18n'

setOptions({
  cMapUrl: '//cdn.jsdelivr.net/npm/pdfjs-dist@2.0.305/cmaps/',
  cMapPacked: true,
  workerSrc: '//cdn.jsdelivr.net/npm/pdfjs-dist@2.0.305/build/pdf.worker.js',
});

const MAX_PDF_PAGES = 50
const TooltipIconButton = Tooltip(IconButton)

const styles ={
  errorContainer: {
    display:'flex', 
    fontSize: 12, 
    overflow: 'auto'
  }
}
class PdfPreviewPage extends React.Component {
  state = {
    width: undefined,
    numPages: 0,
    scale: 1,
    isLoadError: false
  }

  onDocumentLoadSuccess = (document) => {
    this.setState({ numPages: document.numPages, isLoadError: false })
  }

  componentDidMount() {
    setTimeout(()=> {
      this.setState({ width: ReactDOM.findDOMNode(this.ref).clientWidth })
    }, 0)
  }

  onZoomIn = () => {
    const scale = this.state.scale * 1.3
    this.setState({ scale: scale >= 3 ? 3 : scale })
  }
  onZoomOut = () => {
    const scale = this.state.scale * 0.7
    this.setState({ scale: scale <= 1 ? 1 : scale })
  }
  onLoadError = () => this.setState({ isLoadError: true })

  render() {
    const {
      t,
      params,
    } = this.props
    const file = params.file
    const { numPages } = this.state;
    const fontIconStyle = {
      fontSize: 18, 
      position: 'absolute', 
      left: i18next.language == 'ja' ? 210 : 255
    }
    return (
      <RightSidePage title={file.name} icon='picture_as_pdf' ref={(c)=> this.ref = c}
        rightAction={[<TooltipIconButton icon='open_in_new' href={file.file.url} target='_blank' rel="noopener noreferrer" tooltip={t('label:別ウィンドウで表示')} />]}
        absoluteFooter={
          <nav className={pdfPreviewTheme.nav}>
            <div style={{display: 'inline'}} onClick={this.onZoomIn}>
              <TooltipIconButton className={pdfPreviewTheme.navCenter} icon='add_circle_outline' tooltip={t('label:拡大')} />
            </div>
            <div style={{display: 'inline'}} onClick={this.onZoomOut}>
              <TooltipIconButton className={pdfPreviewTheme.navCenter} icon='remove_circle_outline' tooltip={t('label:縮小')} />
            </div>
          </nav>
        } >
        {this.state.isLoadError && <div>
            <div>{t('error:画像の読み込みに失敗しました')}</div>
            <div style={styles.errorContainer}>
              {t('error:暗号化PDF説明')}
              <FontIcon value='open_in_new' style={fontIconStyle}/>
            </div>
          </div>}
        <Document file={file.file.url}
          error={<div></div>}
          loading={t('label:読み込み中')}
          onLoadSuccess={this.onDocumentLoadSuccess} 
          onLoadError={this.onLoadError}>
          {Array.from(new Array(Math.min(numPages, MAX_PDF_PAGES)), (el, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} width={this.state.width * this.state.scale} />
          ))}
        </Document>
        {numPages > MAX_PDF_PAGES && <div style={{ padding: '0 10px', fontSize: '80%', marginBottom: '30px' }}>{t('label:MAXページまでを表示しています')}</div>}
      </RightSidePage>
    );
  }
}

export default translate()(PdfPreviewPage)



// WEBPACK FOOTER //
// ./src/web/components/pdf-preview-page.jsx